(() => {
  const labels = ['MERK', 'MODEL', 'GENERATIE', 'MOTOR'];

  const slugify = text =>
    String(text)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\+/g, 'plus')
      .replace(/[()]/g, '')
      .replace(/[./]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  const addStyles = () => {
    if (document.getElementById('valkor-finder-dropdown-style')) return;

    const style = document.createElement('style');
    style.id = 'valkor-finder-dropdown-style';
    style.textContent = `
      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown {
        position: relative;
        min-width: 0;
        z-index: 1;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown.open {
        z-index: 50;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-trigger {
        width: 100%;
        min-height: 48px;
        padding: 12px 42px 12px 16px;
        border: 1px solid #e10600;
        border-radius: 4px;
        background: #e10600;
        color: #fff;
        font: inherit;
        font-weight: 700;
        text-align: left;
        text-transform: uppercase;
        cursor: pointer;
        position: relative;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-trigger::after {
        content: '⌄';
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-55%);
        font-size: 18px;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-trigger:hover,
      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown.open .valkor-dropdown-trigger {
        background: #ff0000ff;
        border-color: #ff0000ff;
        color: #fff;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-trigger:disabled {
        background: #fff;
        border-color: #ff0000ff;
        color: #bbb;
        cursor: not-allowed;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-menu {
        display: none;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 4px);
        max-height: 280px;
        overflow-y: auto;
        background: #ff0000ff;
        border: 1px solid #ff0000ff;
        border-radius: 4px;
        box-shadow: 0 8px 18px rgba(0, 0, 0, .35);
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown.open .valkor-dropdown-menu {
        display: block;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-option {
        display: block;
        width: 100%;
        padding: 11px 16px;
        border: 0;
        background: #e10600;
        color: #fff;
        font: inherit;
        font-weight: 700;
        text-align: left;
        text-transform: uppercase;
        cursor: pointer;
      }

      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-option:hover,
      .valkor-finder[id^="valkor-finder-"] .valkor-dropdown-option:focus {
        background: #8f0000;
        color: #fff;
      }
    `;

    document.head.appendChild(style);
  };

  const initFinder = root => {
    if (!root || root.dataset.valkorReady === 'true') return;

    const dataElement = document.getElementById(
      'valkor-tags-' + root.id.replace('valkor-finder-', '')
    );

    if (!dataElement) return;

    let tags;

    try {
      tags = JSON.parse(dataElement.textContent).flat();
    } catch (error) {
      console.error('VALKOR vehicle tags could not be read', error);
      return;
    }

    const canonicalByTag = new Map();
    let canonicalOrder = 0;

    if (window.valkorVehicles) {
      Object.entries(window.valkorVehicles).forEach(([make, models]) => {
        Object.entries(models).forEach(([model, generations]) => {
          Object.entries(generations).forEach(([generation, engines]) => {
            engines.forEach(engine => {
              const tag = slugify(
                `${make}_${model}_${generation}_${engine}`
              );

              canonicalByTag.set(tag, {
                values: [make, model, generation, engine],
                order: canonicalOrder++
              });
            });
          });
        });
      });
    }

    const rows = [...new Set(tags)]
      .filter(tag => typeof tag === 'string' && tag.includes('_'))
      .map((tag, index) => {
        const canonical = canonicalByTag.get(tag);

        if (canonical) {
          return {
            tag,
            values: canonical.values,
            order: canonical.order
          };
        }

        const parts = tag.split('_');

        if (parts.length < 4) return null;

        return {
          tag,
          values: [
            parts[0],
            parts[1],
            parts[2],
            parts.slice(3).join('_')
          ],
          order: 1000000 + index
        };
      })
      .filter(Boolean);

    const selects = [...root.querySelectorAll('select')];

    if (selects.length < 4 || !rows.length) return;

    addStyles();

    const controls = selects.map((select, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'valkor-dropdown';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'valkor-dropdown-trigger';
      trigger.textContent = labels[index];

      const menu = document.createElement('div');
      menu.className = 'valkor-dropdown-menu';

      wrapper.append(trigger, menu);
      select.insertAdjacentElement('afterend', wrapper);
      select.style.display = 'none';

      trigger.addEventListener('click', event => {
        event.stopPropagation();

        if (trigger.disabled) return;

        controls.forEach(control => {
          if (control.wrapper !== wrapper) {
            control.wrapper.classList.remove('open');
          }
        });

        wrapper.classList.toggle('open');
      });

      return {
        select,
        wrapper,
        trigger,
        menu
      };
    });

    document.addEventListener('click', () => {
      controls.forEach(control => {
        control.wrapper.classList.remove('open');
      });
    });

    const displayValue = value => String(value).toUpperCase();

const getValues = index => {
  const previousValues = selects
    .slice(0, index)
    .map(select => select.value);

  const orderKey = value =>
    String(value)
      .toLowerCase()
      .replace(/[/.]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const available = new Map();

  rows.forEach(row => {
    const value = row.values[index];
    const key = orderKey(value);

    if (!available.has(key)) {
      available.set(key, value);
    }
  });

  let node = window.valkorVehicles;

  if (!node) {
    return [...available.values()];
  }

  for (let position = 0; position < index; position++) {
    const wanted = orderKey(previousValues[position]);

    const nodeKey = Object.keys(node).find(key =>
      orderKey(key) === wanted
    );

    if (nodeKey === undefined) {
      return [];
    }

    node = node[nodeKey];
  }

  const sourceValues = Array.isArray(node)
    ? node
    : Object.keys(node);

  const values = sourceValues.map(value =>
    available.get(orderKey(value)) || value
  );

  return [
    ...new Map(
      values.map(value => [orderKey(value), value])
    ).values()
  ];
};

    const setOptions = (index, values) => {
      const control = controls[index];
      const select = control.select;

      select.innerHTML = '';
      control.menu.innerHTML = '';
      control.trigger.textContent = labels[index];

      values.forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = displayValue(value);
        select.appendChild(option);

        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'valkor-dropdown-option';
        item.textContent = displayValue(value);

        item.addEventListener('click', event => {
          event.stopPropagation();

          select.value = value;
          control.trigger.textContent = displayValue(value);
          control.wrapper.classList.remove('open');

          select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        });

        control.menu.appendChild(item);
      });
    };

    const setDisabled = (index, disabled) => {
      controls[index].select.disabled = disabled;
      controls[index].trigger.disabled = disabled;

      if (disabled) {
        controls[index].trigger.textContent = labels[index];
        controls[index].wrapper.classList.remove('open');
      }
    };

    const resetFrom = index => {
      for (let next = index; next < selects.length; next++) {
        selects[next].innerHTML = '';
        selects[next].value = '';
        controls[next].menu.innerHTML = '';
        controls[next].trigger.textContent = labels[next];
        setDisabled(next, true);
      }
    };

    const fill = index => {
      const values = getValues(index);
      setOptions(index, values);

      setDisabled(
        index,
        index > 0 && !selects[index - 1].value
      );
    };

    fill(0);
    resetFrom(1);

    selects.forEach((select, index) => {
      select.addEventListener('change', () => {
        resetFrom(index + 1);

        if (index < selects.length - 1) {
          fill(index + 1);
          return;
        }

const selectedRow = rows.find(row =>
  row.values.every((value, position) =>
    value === selects[position].value
  )
);

const selectedTag = selectedRow
  ? selectedRow.tag
  : slugify(
      selects
        .map(select => select.value)
        .join('_')
    );

if (selectedTag) {
  window.location.href =
    root.dataset.collectionUrl.replace(/\/$/, '') +
    '/' +
    encodeURIComponent(selectedTag);
}
      });
    });

    root.dataset.valkorReady = 'true';
  };

  const start = () => {
    document
      .querySelectorAll('.valkor-finder[id^="valkor-finder-"]')
      .forEach(initFinder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      event.target
        .querySelectorAll?.('.valkor-finder[id^="valkor-finder-"]')
        .forEach(initFinder);
    }
  );
})();
